export const enum InvoiceType {
  Invoice = 1,
  Refund = 2,
}
